import axios from 'axios'
import { Component } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'
import ButtonControl from '../button-control'

interface Props {
  webmaster: string[]
  emails: string[]
  name: string
  secondaryWebmaster: string[]
  secondaryName: string
}

interface State {
  loading: boolean
}

interface WebmasterComponentProps {
  setWebmaster: (
    isSecondary: boolean,
    data: {
      email: string
      name: string
    }
  ) => void
  loading: boolean

  isSecondary: boolean
  title: string

  emails: string[]
  email: string
  name: string
}

class WebmasterSetup extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      loading: false
    }

    this.setWebmaster = this.setWebmaster.bind(this)
  }

  async setWebmaster(isSecondary: boolean, { name, email }: { name: string; email: string }) {
    this.setState({ loading: true })

    try {
      await axios.post('/settings/emailManagement/saveWebmaster', {
        email,
        name,
        secondary: isSecondary
      })
      this.setState({ loading: false })
      window.location.reload()
    } catch (e) {
      this.setState({ loading: false })
      console.log('e ', e)
    }
  }

  render() {
    if (this.props.emails.length === 0) {
      return null
    }

    return (
      <div className='email-setup'>
        <h3>Email Setup</h3>

        <WebmasterComponent
          loading={this.state.loading}
          emails={this.props.emails}
          email={this.props.webmaster.length > 0 ? this.props.webmaster[0] : ''}
          name={this.props.name}
          isSecondary={false}
          title='System emails:'
          setWebmaster={this.setWebmaster}
        />

        <WebmasterComponent
          loading={this.state.loading}
          emails={this.props.emails}
          email={this.props.secondaryWebmaster.length > 0 ? this.props.secondaryWebmaster[0] : ''}
          name={this.props.secondaryName}
          isSecondary
          title='Email campaigns:'
          setWebmaster={this.setWebmaster}
        />
      </div>
    )
  }
}

class WebmasterComponent extends Component<
  WebmasterComponentProps,
  {
    emails: string[]
    email: string
    name: string
  }
> {
  constructor(props: WebmasterComponentProps) {
    super(props)
    this.state = {
      emails: props.emails,
      email: props.email,
      name: props.name
    }
  }

  render() {
    const { props } = this
    return (
      <div className='form'>
        <div className='row'>
          <label for='webmaster'>{props.title}</label>
          <InputGroup
            type='text'
            placeholder='eg: Insided Community'
            value={props.name}
            onChange={(e) => this.setState({ name: e.target.value })}
          />
          <select
            className='webmasterSelector'
            onChange={(e: any) => {
              this.setState({ email: e.target.value })
            }}
          >
            <option disabled selected={!!props.email}>
              Select your option
            </option>
            {props.emails.map((email, index) => (
              <option key={index} selected={!!props.email && email === this.props.email}>
                {email}
              </option>
            ))}
          </select>
          <ButtonControl
            variant='success'
            title='Save'
            isLoading={props.loading}
            onClick={() =>
              props.setWebmaster(props.isSecondary, {
                email: this.state.email,
                name: this.state.name
              })
            }
          />
        </div>
      </div>
    )
  }
}

export { WebmasterComponent }
export default WebmasterSetup
